export default __webpack_public_path__ + "static/media/kurniawan.47a63fed.png";